import React, {  useEffect, useState } from "react";
import { Col, Drawer, Dropdown, Modal, Table, Tag, Typography } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { ItemType } from "antd/es/menu/interface";
import { MazakaBull } from "apps/Common/MazakaBull";
import { RootState } from "store/Reducers";
import { useSelector } from "react-redux";
import { deletePortfolioUserByStore } from "../Services";

import {
  
  useGetPortfolioUserByStoreFilter,
} from "../ServerSideStates";
import AddOrUpdateUser from "./AddOrUpdate/AddOrUpdateUser";
import { MazakaDrawer } from "apps/Common/MazakaDrawer";
import UserShoppingList from "./UserShoppingList";

const { Text } = Typography;

const ListItems = () => {
  const [isShowEditDrawer, setIsShowEditDrawer] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
  const queryClient = useQueryClient();
  const { filter } = useSelector((state: RootState) => state.userManagement);
  const[isShowUserShoppingList,setIsShowShoppingList] = useState(false)
  const [data,setData] = useState<any>([])

  const columns = [

      {
        title: "Adı Soyadı",
  
        render: (_: string, record: any) => {
          return (
            <>
              <div className="!flex gap-3 items-center">
               
                <div>
                  <div>
                    <Text>{`${record?.name || ""} ${
                      record?.surname || ""
                    }`}</Text>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
  
   

    {
      title: "Telefon",
      dataIndex:"phoneNumber",

      render: (text: string,) => {
        return (
          <>
            
                <Text   >
                {text}
                </Text>
             
          </>
        );
      },
    },
    {
      title: "E-Posta",
      dataIndex: "eMail",
      render: (email: string) => {
        return (
          <>
          <Text   >
                {email}
                </Text>
          </>
        );
      },
    },

    {
      title: "Mağazalar",

      render: (text: string, record: any) => {
        return (
          <>
          {/* {
            record?.storePortfolioUser?.map((item:any)=>{
              return(
                <>
                   <Tag color="blue" >{item.store?.storeName||""}</Tag>
                </>
              )
            })

          } */}
            {
            
            <div
            onClick={async()=>{
              
              await setSelectedRecord(record)
              setIsShowShoppingList(true)

            }} 
            className="!flex gap-2 cursor-pointer"
            >

            <FormOutlined className="!textx-lg !text-blue-500" />
            <Text className="!text-indigo-500" >Mağazaları görmek için tıklayınız</Text>
            </div>
            }  
          </>
        );
      },
    },

   
  


    {
      title: "Durum",
      dataIndex: "active",
      key: "active",
      render: (status: boolean) => (
        <MazakaBull type={status ? "Success" : "Error"} />
      ),
    },

    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "8%",
      render: (key: any, record: any) => (
        <Col className="text-end pr-2">
          <Dropdown menu={{ items: tableItemDropdownMenu(record) }}>
           {record?.isMultipleStore?<></>:<EllipsisOutlined className="text-xl" />} 
          </Dropdown>
        </Col>
      ),
    },
  ];

  const tableItemDropdownMenu = (record: any): ItemType[] => {
  
   return [
    {
      key: "1",
      onClick: async () => {
        await setSelectedRecord(record);
        setIsShowEditDrawer(true);
      },
      icon: <EditOutlined />,
      label: "Kullanıcıyı Güncelle",
    },
    // {
    //   key: "2",
    //   onClick: () => {
    //     confirm(record);
    //   },
    //   icon: <DeleteOutlined />,
    //   label: "Kullanıcıyı Sil",
    // },
  ];
  }
  
  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          
          await deletePortfolioUserByStore(record);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endPoints.getPortfolioUserByStoreFilter,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const users = useGetPortfolioUserByStoreFilter(filter);
  
  const mergedStores = (users: any[]): any[] => {
    const result: Record<string, any> = {};
  
    users.forEach((user) => {
      const { eMail, storePortfolioUser, id, isAuthPostAdvert, ...rest } = user;
  
      if (!result[eMail]) {
        result[eMail] = {
          ...rest,
          eMail,
          isMultipleStore: true,
          storeList: [],
        };
      }
  
      // storePortfolioUser dizisindeki her öğeyi kontrol et
      storePortfolioUser.forEach((storeItem: any) => {
        const storeObject = {
          store: storeItem.store,
          invitationStatus: storeItem.invitationStatus,
          userId: id,
          isAuthPostAdvert,
        };
  
        // Aynı store daha önce eklenmiş mi kontrol et
        const isStoreExists = result[eMail].storeList.some(
          (s: any) => s.store.id === storeItem.store.id
        );
  
        if (!isStoreExists) {
          result[eMail].storeList.push(storeObject);
        }
      });
    });
  
    return Object.values(result);
  };
  
  
  

  useEffect(() => {
    if (users.data?.data?.data) {
      const allUsers = users?.data?.data?.data || [];
      const emailCount: Record<string, number> = {};
  
      // E-posta adreslerini say
      allUsers.forEach((user: { eMail: string }) => {
        emailCount[user.eMail] = (emailCount[user.eMail] || 0) + 1;
      });
  
      // Aynı ve benzersiz kullanıcıları ayır
      const sameUser = allUsers.filter((user: { eMail: string }) => emailCount[user.eMail] > 1);
      const uniqueUser = allUsers.filter((user: { eMail: string }) => emailCount[user.eMail] === 1);
  
    
      setData([...uniqueUser,...mergedStores(sameUser)])
  
      
    }
  }, [users.data]);
  
  



  return (
    <>
      <Table
        columns={columns}
        dataSource={data }
        loading={users.isLoading || users.isFetching}
        rowKey={"id"}
        pagination={{
          position: ["bottomRight"],
          className: "!px-0",
          // onChange: handleChangePagination,
          total: users?.data?.data?.length || 0,
          pageSize: 20,
          showLessItems: true,
          size: "small",
          showSizeChanger: true,
          locale: { items_per_page: "" },
          showTotal: (e) => `${e}`,
        }}
      />
      <Drawer
        open={isShowEditDrawer}
        onClose={() => {
          setIsShowEditDrawer(false);
        }}
      >
        <AddOrUpdateUser
        type="user"
          selectedRecord={selectedRecord}
          onFinish={() => {
           
            queryClient.resetQueries({
              queryKey: endPoints.getPortfolioUserByStoreFilter,
              exact: false,
            });
            setIsShowEditDrawer(false);
          }}
        />
      </Drawer>

      <MazakaDrawer
        title={<Text className="!font-bold !text-2xl">{`${selectedRecord?.name||""} ${selectedRecord?.surname}`}</Text>}
        open={isShowUserShoppingList}
        toggleVisible={() => {
          setIsShowShoppingList(!isShowUserShoppingList);
          
        }}
        layoutType="strecth"
      >

      <UserShoppingList
      data={selectedRecord}
      />
      </MazakaDrawer>
    </>
  );
};

export default ListItems;
